<template lang="pug">
	.project-version-preview-delete(v-if="showed && preview")
		.card
			.card-header
				i.fa.fa-edit
				span Delete Preview
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label Are you sure you want to delete project version preview "{{preview.hash}}"?
					.form-actions
						button.btn.btn-danger(type="submit" v-on:click="deletePreview()") Delete preview
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Project } 			from './../../services/Project';
	import { Settings } 		from './../../services/Settings';

	export default {
		name: "ProjectVersionPreviewDelete",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Project = Project;
			this.Settings = Settings;

			this.preview = null;

			return {

			};

		},
		methods: {
			collectData(eventName, preview) {

				this.preview = preview;

			},
			deletePreview() {

				Server.sendToSocket({
					DeletePreview: this.preview.id
				});

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.project-version-preview-delete
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 180px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark
				float: right
				color: #fff

</style>

